import { MAPPINGS_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { setAddressDetail } from "@/app_redux/reducers/slices/auth/cart_slice";
import { IAppointmentCartItemsMappingListResponse } from "@/api_framework/api_modals/Mapping";
import { setAppointmentCartItemMappingDetail } from "@/app_redux/reducers/slices/auth/mapping_slice";

AxiosCurlirize(axios, () => {});

export const useAppointmentCartItemsMappingDetailAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (subServiceId: string) => {
      try {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(`${MAPPINGS_APIS?.APPOINTMENT_CART_ITEMS_MAPPING_LIST?.baseURL}${subServiceId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAppointmentCartItemsMappingListResponse>) => {
            if (res.data.status === true) {
              dispatch(setAppointmentCartItemMappingDetail({ data: res.data.data as any }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: true, message: res.data.message };
            } else {
              dispatch(setAppointmentCartItemMappingDetail({ data: null }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setAppointmentCartItemMappingDetail({ data: null }));
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            const message = e.response.data as any;
            return { status: false, message: message.message };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: false,
          }),
        );
        dispatch(setAddressDetail(null));
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
